(function () {
  'use strict';

  // Patch: prevent broken removeEventListener calls
  var origRemove = EventTarget.prototype.removeEventListener;
  EventTarget.prototype.removeEventListener = function(type, listener, options) {
    if (!listener) return;
    return origRemove.call(this, type, listener, options);
  };

  /* ---- bfcache: Back/Forward button fix ---- */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;

    // 1. Disconnect TinyIMG MutationObserver to stop it from re-breaking things
    if (typeof uLTS !== 'undefined' && uLTS.disconnect) {
      try { uLTS.disconnect(); } catch(ex) {}
    }

    // 2. Force TinyIMG's loadJSscripts if not already fired
    if (typeof script_loaded !== 'undefined' && !script_loaded) {
      try { loadJSscripts(); } catch(ex) {}
    }

    // 3. Manually restore any remaining deferred resources
    document.querySelectorAll('iframe[data-src], script[data-src]').forEach(function (el) {
      if (el.dataset.src && !el.src) el.src = el.dataset.src;
    });

    document.querySelectorAll('link[data-href]').forEach(function (link) {
      if (link.dataset.href && !link.href) link.href = link.dataset.href;
    });

    // 4. Restore lazy scripts (text/lazyload -> text/javascript)
    document.querySelectorAll("script[type='text/lazyload']").forEach(function (old) {
      var newScript = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        newScript.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      newScript.type = 'text/javascript';
      newScript.innerHTML = old.innerHTML;
      old.parentNode.insertBefore(newScript, old);
      old.parentNode.removeChild(old);
    });

    // 5. Reset Shopify menu drawers / modals (global.js fix)
    document.querySelectorAll('menu-drawer, header-drawer').forEach(function(drawer) {
      try {
        var details = drawer.querySelector('details[open]');
        if (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        }
        document.body.className = document.body.className.replace(/overflow-hidden-\w+/g, '');
      } catch(ex) {}
    });

    document.querySelectorAll('modal-dialog[open]').forEach(function(modal) {
      try { modal.hide(); } catch(ex) {}
    });

    // 6. Reset trap focus (prevents removeEventListener error)
    if (typeof removeTrapFocus === 'function') {
      try { removeTrapFocus(); } catch(ex) {}
    }

    // 7. Re-init lazysizes
    if (window.lazySizes) {
      try { window.lazySizes.init(); } catch(ex) {}
    }

    // 8. Re-init image zoom
    if (typeof initImageZoom === 'function') {
      setTimeout(initImageZoom, 500);
    }

    // 9. Re-fire deferred loading events
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
      document.dispatchEvent(new CustomEvent('loadBarInjector'));
    }, 300);
  });

  // Clean up before bfcache storage
  window.addEventListener('pagehide', function () {
    var pf = document.querySelector('link[rel="prefetch"]');
    if (pf) pf.removeAttribute('href');
  });
})();